module.exports = {
    MODE: 'staging',
    DOMAIN: 'optimize-user.isp99.com',
    API_ENDPOINT: 'https://optimize-staging.isp99.com/api',
    // DOMAIN: 'admin.optimize99.com',
    // API_ENDPOINT: 'https://api.optimize99.com/api',
    LOG_ENDPOINT: 'https://enterprise.nineder.com/flows/trigger/c234e797-e690-42a8-a388-606578258739',
    LOG_LEVEL: {
      "info": "Info",
      "warning": "Warning",
      "error": "Error"
    }
};